<app-tab-form-modal
  [model$]="model$"
  [summaryItems]="summaryTopItems"
  [baseService]="addressService"
  [isModal]="isModal()"
>
  <app-tab
    [model]="model$ | async"
    [templates]="[
      { header: detailsHeader, template: details },
      { header: addresseeHeader, template: addressees },
    ]"
  >
  </app-tab>
</app-tab-form-modal>

<ng-template #details>
  <app-address-details [id]="id()"></app-address-details>
</ng-template>

<ng-template #addressees>
  <app-address-addressees [addressId]="id()"></app-address-addressees>
</ng-template>
